import axios from "axios";

const KEY = "rq_consumer_token";
const cAuth = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
cAuth.interceptors.request.use((c) => {
  const t = localStorage.getItem(KEY);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export function formatErr(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg || JSON.stringify(e))).join(" ");
  return detail?.msg || String(detail);
}

function keepConsumerToken(data) {
  if (data?.user && data.user.role !== "consumer") {
    const e = new Error("staff-account");
    e.response = { data: { detail: "That email belongs to a staff account. Use your personal email for the ResQ1 app." } };
    throw e;
  }
  localStorage.setItem(KEY, data.access_token);
  return data;
}

export async function registerConsumer(payload) {
  const { data } = await cAuth.post("/auth/consumer/register", payload);
  return keepConsumerToken(data);
}
export async function setPassword(payload) {
  const { data } = await cAuth.post("/auth/consumer/set-password", payload);
  return keepConsumerToken(data);
}
export async function loginConsumer(email, password) {
  const { data } = await cAuth.post("/auth/login", { email, password });
  return keepConsumerToken(data);
}
export async function fetchProfile() {
  const { data } = await cAuth.get("/consumer/profile");
  return data;
}
export function logoutConsumer() { localStorage.removeItem(KEY); }
export function hasSession() { return !!localStorage.getItem(KEY); }

export async function createSos(payload = {}) {
  const { data } = await cAuth.post("/consumer/sos", payload);
  return data;
}
export async function getNotices() {
  const { data } = await cAuth.get("/consumer/notices");
  return data;
}
export async function getHousehold() {
  const { data } = await cAuth.get("/consumer/household");
  return data;
}
export async function cancelSos(id) {
  const { data } = await cAuth.post(`/consumer/sos/${id}/cancel`);
  return data;
}
export async function inviteMember(payload) {
  const { data } = await cAuth.post("/consumer/household/invite", payload);
  return data;
}
export async function addHouseholdMember(payload) {
  const { data } = await cAuth.post("/consumer/household/members", payload);
  return data;
}
export async function editHouseholdMember(memberId, patch) {
  const { data } = await cAuth.patch(`/consumer/household/members/${memberId}`, patch);
  return data;
}

export async function removeHouseholdMember(id) {
  const { data } = await cAuth.delete(`/consumer/household/members/${id}`);
  return data;
}
export async function setLocationSharing(enabled) {
  const { data } = await cAuth.put("/consumer/location-sharing", { enabled });
  return data;
}
export async function pushLocation(payload) {
  const { data } = await cAuth.post("/consumer/location", payload);
  return data;
}
export async function getFamilyLocations() {
  const { data } = await cAuth.get("/consumer/family-locations");
  return data;
}
export async function requestUpgrade() {
  const { data } = await cAuth.post("/consumer/upgrade-request");
  return data;
}
export async function getPlans() {
  const { data } = await cAuth.get("/plans");
  return data;
}
export async function getMySubscription() {
  const { data } = await cAuth.get("/consumer/subscription");
  return data;
}
export async function startSubscription(payload) {
  const { data } = await cAuth.post("/consumer/subscription/start", payload);
  return data;
}
export async function signSubscription(sid, payload) {
  const { data } = await cAuth.post(`/consumer/subscription/${sid}/sign`, payload);
  return data;
}
export async function linkMainMember(mainCell) {
  const { data } = await cAuth.post("/consumer/household/link-main", { main_cell: mainCell });
  return data;
}
export async function getEnrichment() {
  const { data } = await cAuth.get("/consumer/enrichment");
  return data;
}
export async function saveEnrichment(payload) {
  const { data } = await cAuth.put("/consumer/enrichment", payload);
  return data;
}
export async function forgotPassword(email) {
  const { data } = await cAuth.post("/auth/forgot-password", { email });
  return data;
}
export async function resetPassword(token, password) {
  const { data } = await cAuth.post("/auth/reset-password", { token, password });
  return data;
}
export async function getInvitePrefill(token) {
  const { data } = await cAuth.get(`/consumer/invite/${token}`);
  return data;
}
export async function getMyDebitOrder() {
  const { data } = await cAuth.get("/consumer/debit-order");
  return data;
}
export async function signMyDebitOrder(payload) {
  const { data } = await cAuth.post("/consumer/debit-order/sign", payload);
  return data;
}

export async function lookupCover(cell) {
  const { data } = await cAuth.post("/consumer/lookup", { cell });
  return data;
}
export async function lookupByEmail(email) {
  const { data } = await cAuth.post("/consumer/lookup", { email });
  return data;
}
